// Хелперы диагностического логирования фото. Только считают метрики,
// НИЧЕГО не меняют. Каждая функция в try/catch и не бросает.

// Атрибуты файла без чтения пикселей — мгновенно.
export function fileMeta(file) {
  try {
    if (!file) return {};
    return {
      file_name: file.name || "",
      file_type: file.type || "",
      file_bytes: file.size || 0,
      file_kb: file.size ? Math.round(file.size / 1024) : 0,
    };
  } catch (e) {
    return {};
  }
}

// Размеры + EXIF-поворот + тёмные края ВСЕГО фото.
// Тяжёлая часть — вызывается только при выборе файла (async, не в критич. пути).
export async function imageMeta(file) {
  try {
    if (!file || !file.type || !file.type.startsWith("image/")) return {};
    let raw = null, oriented = null;
    try {
      const b1 = await createImageBitmap(file, { imageOrientation: "none" });
      raw = { w: b1.width, h: b1.height };
      if (b1.close) b1.close();
    } catch (e) {}
    let bmp = null;
    try {
      bmp = await createImageBitmap(file, { imageOrientation: "from-image" });
      oriented = { w: bmp.width, h: bmp.height };
    } catch (e) {}

    const src = oriented || raw;
    if (!src) return {};
    const meta = {
      nat_w: src.w,
      nat_h: src.h,
      megapixels: +(src.w * src.h / 1e6).toFixed(2),
      aspect: +(src.w / src.h).toFixed(4),
      exif_rotated: raw && oriented ? (raw.w !== oriented.w || raw.h !== oriented.h) : null,
    };

    // тёмные края всего фото (дёшево, на копии 64px)
    try {
      if (bmp) {
        const c = document.createElement("canvas");
        c.width = 64; c.height = 64;
        const ctx = c.getContext("2d", { willReadFrequently: true });
        ctx.drawImage(bmp, 0, 0, 64, 64);
        const lum = (d, i) => d[i] * 0.299 + d[i + 1] * 0.587 + d[i + 2] * 0.114;
        const darkFrac = (data) => {
          let dk = 0; for (let i = 0; i < data.length; i += 4) if (lum(data, i) < 40) dk++;
          return +(dk / (data.length / 4)).toFixed(3);
        };
        const k = 3;
        meta.edge_left = darkFrac(ctx.getImageData(0, 0, k, 64).data);
        meta.edge_right = darkFrac(ctx.getImageData(64 - k, 0, k, 64).data);
        meta.edge_top = darkFrac(ctx.getImageData(0, 0, 64, k).data);
        meta.edge_bottom = darkFrac(ctx.getImageData(0, 64 - k, 64, k).data);
      }
    } catch (e) {}
    if (bmp && bmp.close) bmp.close();
    return meta;
  } catch (e) {
    return {};
  }
}